<template>
  <!-- eslint-disable vue/no-lone-template -->
  <div v-if="!loader" :class="noResult ? 'p-4 text-center' : 'body-wrapper'">
    <template v-if="!noResult">
      <button
        class="button create-invoice-button"
        @click="handleCreateInvoiceClick"
      >
        <img
          src="/static/icons/supplier-create-invoice-icon.svg"
        />สร้างใบแจ้งหนี้
      </button>
      <div class="title">ตรวจสอบสถานะงาน</div>
      <div class="statistic-wrapper">
        <div v-for="result in dashboardResults" :key="result.type">
          <body-item :result="result" @onItemClick="handleItemClick" />
        </div>
      </div>
    </template>
    <template v-else>ไม่มีข้อมูล</template>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import DashboardBodyItem from "./InvoiceDashboardBodyItem"

export default {
  components: { "body-item": DashboardBodyItem },
  props: {
    status: {
      type: null,
      default: undefined,
    },
    activeStatus: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      dashboardResults: [],
    }
  },
  computed: {
    loader() {
      return this.$store.state.loader
    },
    noResult() {
      return this.dashboardResults.length === 0
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      if (this.status === this.activeStatus) {
        await this.setupDashboard()
      }
    },
  },
  created() {
    this.setupData()
  },
  methods: {
    async setupData() {
      await this.setupDashboard()
    },
    async setupDashboard() {
      const dashboards = await this.fetchDashboard()

      this.dashboardResults = dashboards.map((dashboard) => ({
        type: dashboard.type,
        title: dashboard.title,
        value: dashboard.value,
      }))
    },
    async fetchDashboard() {
      return baanRueJaiClient.others.supplier.getInvoiceDashboard()
    },
    handleItemClick(status) {
      if (status === this.status) {
        this.navigateToCreateInvoicePage()
      } else {
        this.$emit("onItemClick", status)
      }
    },
    handleCreateInvoiceClick() {
      if (this.canCreateInvoice()) {
        this.navigateToCreateInvoicePage()
      } else {
        this.$message.error("ไม่มีนัดหมายสำหรับวางบิล")
      }
    },
    navigateToCreateInvoicePage() {
      this.$router.push({ name: "SupplierCreateInvoice" })
    },
    canCreateInvoice() {
      return this.dashboardResults[0] && this.dashboardResults[0].value > 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.body-wrapper {
  display: flex;
  flex-direction: column;
}

.button {
  margin-top: 24px;
  margin-inline: 32px;
  padding-inline: 24px;
  height: 54px;
  font-weight: bold;
  font-size: $font-16;
  border-radius: 8px;
  align-items: center;
  margin-right: auto;

  img {
    margin-right: 8px;
  }
}

.create-invoice-button {
  color: $white;
  background: $supplier-primary-color;
  border: none;

  &:hover:not(:disabled) {
    background: $supplier-primary-light-color;
  }
}

.title {
  font-size: $font-22;
  font-weight: bold;
  margin-top: 24px;
  margin-inline: 32px;
}

.statistic-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 16px;
  padding-block: 16px;
  padding-inline: 32px;
}

@media (max-width: ($m-size - 1)) {
  .button {
    margin-top: 16px;
    margin-inline: 20px;
    padding-inline: 12px;
    height: 48px;
  }

  .title {
    font-size: $font-18;
    margin-top: 16px;
    margin-inline: 20px;
  }

  .statistic-wrapper {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 12px;
    padding-block: 8px;
    padding-inline: 20px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .button {
    margin-top: 16px;
    margin-inline: 20px;
    padding-inline: 20px;
    height: 48px;
    margin-right: auto;
  }

  .title {
    font-size: $font-18;
    margin-top: 16px;
    margin-inline: 20px;
  }

  .statistic-wrapper {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 12px;
    padding-block: 8px;
    padding-inline: 20px;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .button {
    margin-top: 20px;
    margin-inline: 24px;
    padding-inline: 24px;
    height: 48px;
    margin-right: auto;
  }

  .title {
    font-size: $font-20;
    margin-top: 20px;
    margin-inline: 24px;
  }

  .statistic-wrapper {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    padding-block: 12px;
    padding-inline: 24px;
  }
}
</style>
